
t = require('views/internal/teacup-with-helpers')('board_menu_power_up_slot')

emptySlot = t.renderable ->
  t.li '.board-menu-navigation-item.mod-power-up-slot', ->
    t.a '.board-menu-navigation-item-link.js-power-up-empty-slot', { href: '#' }, ->
      t.span '.board-menu-navigation-item-link-icon'
      t.raw '&nbsp;'
      t.format 'add-power-up'

upsellSlot = t.renderable ->
  t.li '.board-menu-navigation-item.mod-power-up-slot', ->
    t.a '.board-menu-navigation-item-link.js-power-up-slot-upsell', { href: '#' }, ->
      t.span '.board-menu-navigation-item-link-icon'
      t.raw '&nbsp;'
      t.format 'unlock-more-power-ups'

powerUpSlot = t.renderable ({ id, name, icon }) ->
  t.a '.board-menu-navigation-item-link.mod-enabled', { href: '#' }, ->
    t.span '.board-menu-navigation-item-link-icon.mod-enabled', style: "background-image: url(#{icon.url})"
    t.raw '&nbsp;'
    t.text name

module.exports = {
  emptySlot
  upsellSlot
  powerUpSlot
}



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_menu_power_up_slot.coffee